<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->
        <h3>3.1、车速数据</h3>

        <!-- ECharts 柱状图容器 -->
        <div ref="speedChart" class="chart-container" style="height: 280px;margin-top: 15px;"></div>
        <div class="table-caption">图表1</div>
        <!-- 横向多列表格（完全匹配截图） -->
        <el-table :data="speedTableData" size="mini" border :cell-class-name="tableCellClassName" :show-header="false"
            style="width: 100%; margin-top: 15px;">
            <!-- 动态渲染列（车速区间） -->
            <el-table-column v-for="col in tableColumns" :key="col.prop" :prop="col.prop" :width="col.width"
                align="center" />
        </el-table>
        <div class="table-caption">数据表1</div>

        <!-- 说明文本 -->
        <div class="note">
            <p>说明：</p>
            <p>1.按相关法规规定, 公路车最高车速不得高于100km/h, 专用校车最高车速不得高于80km/h, 公交车最高车速小于70km/h;</p>
            <p>2.采集期内的最高车速为99.00km/h。</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "barchart",

    data() {
        return {


            tableColumns: [
                { prop: 'label', label: '车速(km/h)', width: 70 },
                { prop: 's0', label: '0', width: 40 },
                { prop: 's10', label: '≤10', width: 40 },
                { prop: 's20', label: '≤20', width: 40 },
                { prop: 's30', label: '≤30', width: 40 },
                { prop: 's40', label: '≤40', width: 40 },
                { prop: 's50', label: '≤50', width: 40 },
                { prop: 's60', label: '≤60', width: 40 },
                { prop: 's70', label: '≤70', width: 40 },
                { prop: 's80', label: '≤80', width: 40 },
                { prop: 's90', label: '≤90', width: 40 },
                { prop: 's100', label: '≤100', width: 46 },
                { prop: 's110', label: '≤110', width: 46 },
                { prop: 's120', label: '≤120', width: 46 },
                { prop: 's120_', label: '>120', width: 46 },
                { prop: 'total', label: '累计', width: 62 }
            ],
            // 表格数据（完全匹配截图）
            speedTableData: [
                // 第一行：车速区间
                {
                    label: '车速(km/h)',
                    s0: '0', s10: '≤10', s20: '≤20', s30: '≤30', s40: '≤40', s50: '≤50', s60: '≤60',
                    s70: '≤70', s80: '≤80', s90: '≤90', s100: '≤100', s110: '≤110', s120: '≤120', s120_: '>120',
                    total: '累计'
                },
                // 第二行：时间(小时)
                {
                    label: '时间(小时)',
                    s0: '20.91', s10: '1.63', s20: '1.64', s30: '1.96', s40: '1.5', s50: '1.62', s60: '2.04',
                    s70: '1.47', s80: '1.06', s90: '0.38', s100: '0.2', s110: '0', s120: '0', s120_: '0',
                    total: '34.41'
                },
                // 第三行：百分比(%)
                {
                    label: '百分比(%)',
                    s0: '60.77', s10: '4.74', s20: '4.76', s30: '5.71', s40: '4.37', s50: '4.7', s60: '5.93',
                    s70: '4.27', s80: '3.08', s90: '1.1', s100: '0.57', s110: '0', s120: '0', s120_: '0',
                    total: '100'
                }
            ]
        };
    },
    mounted() {
        this.initSpeedChart();
    },
    methods: {
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            if (rowIndex == 0) {
                if (column.property == 's110' || column.property == 's120' || column.property == 's120_') {
                    return "cell-header-warning";
                }
                return "cell-header";
            }

            if (column.property == 's110' || column.property == 's120' || column.property == 's120_') {
                return "cell-header-warning";
            }


        },
        // 合并单元格方法
        initSpeedChart() {
            const chartDom = this.$refs.speedChart;
            const myChart = echarts.init(chartDom);

            // 图表配置
            const option = {
                title: {
                    text: '',
                    left: 'center',

                },
                backgroundColor: '#E2F0FF',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                grid: {
                    left: '3%',
                    bottom: '8%',
                    right: '3%',
                    containLabel: true
                },
                xAxis: {
                    name: '车速(km/h)',
                    nameLocation: 'center',
                    nameGap: 40,
                    type: 'category',
                    data: ['0', '≤10', '≤20', '≤30', '≤40', '≤50', '≤60', '≤70', '≤80', '≤90', '≤100', '≤110', '≤120', '>120'],
                    axisLabel: {
                        rotate: 45,
                        interval: 0
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '百分比(%)'
                },
                series: [
                    {
                        data: [60.77, 4.74, 4.76, 5.71, 4.37, 4.7, 5.93, 4.27, 3.08, 1.1, 0.57, 0, 0, 0],
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top'
                        },
                        itemStyle: {
                            color: '#409EFF' // 柱状图颜色（ElementUI 主色）
                        }
                    }
                ]
            };

            myChart.setOption(option);

            // 监听窗口 resize，自适应图表
            window.addEventListener('resize', () => {
                myChart.resize();
            });
        }
    }
};
</script>
<style scoped>
.chart-container {
    width: 100%;
    background: #f9fafc;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
}

::v-deep .el-table .cell {
    padding: 4px 0;
    font-size: 8pt !important;

}

::v-deep .cell-header-warning {
    background: #dba8a8 !important;
    color: #000 !important;
    border-bottom: 1px solid #000 !important;
    border-right: 1px solid #000 !important;
}

.table-caption {
    text-align: center;
    margin: 8px 0;
    font-weight: 500;
}
</style>